import { MenuDashboard } from "./menu-dashboard";

export class MenuEstadistica {
    id!: number;
    idPadre!: number;
    clasificacionMenu!:string;
    direccion_a_tabla!:string;
    mostrarHijos!:string;
    nombre!: string;
    enlace_pagina_externa!: string;
    enlace_reporte_tabla!: string;
    enlace_dashboard!: string;
    idMenuJson!: string;
    idSubmenuJson!: string;
    periodicidad!:string;
    unidadMedida!:string;

    ordenMenu!:number;
    ordenCalendario!:number;

    estiloClase!:string;
    
    menuHijos: Array<MenuEstadistica> = new Array();
    listaMenuDashBoard:Array<MenuDashboard> = new Array();

    listaDocumento:Array<any> = new Array();
}
